import Vue from 'vue'
// 判断当前登录设备
Vue.prototype._isMobile = (() => {
  return window.screen.width < 960
})()
